/* Wolki Farm — Meat Cut PDP interactive layer. */
(function () {
  "use strict";
  var root = document.querySelector(".mc-page");
  if (!root) return;

  var dataEl = document.getElementById("mc-data");
  var data = {};
  try { data = JSON.parse(dataEl.textContent); } catch (e) {}

  var AUD = function (n) {
    var r = Math.round(n * 100) / 100;
    return "$" + r.toLocaleString("en-AU", { minimumFractionDigits: r % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  };

  var state = { variantId: data.defaultVariantId, variantPrice: data.defaultPrice || 0, subscribe: false };

  var varBtns = root.querySelectorAll("[data-mc-var]");
  var purchaseBtns = root.querySelectorAll("[data-mc-purchase]");
  var totalOut = root.querySelectorAll("[data-mc-out='total']");
  var ctaTotalOut = root.querySelectorAll("[data-mc-out='cta-total']");
  var buyBtns = root.querySelectorAll("[data-mc-addtocart]");
  var stickyEl = root.querySelector("[data-mc-sticky-cta]");
  var buyboxEl = root.querySelector("[data-mc-buybox]");
  var topBtn = root.querySelector("[data-mc-totop]");

  function render() {
    totalOut.forEach(function (el) { el.textContent = AUD(state.variantPrice); });
    ctaTotalOut.forEach(function (el) { el.textContent = AUD(state.variantPrice); });
  }

  var backorderEl = root.querySelector("[data-mc-backorder-note]");
  varBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      varBtns.forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
      btn.setAttribute("aria-pressed", "true");
      state.variantId = btn.getAttribute("data-mc-variant-id");
      state.variantPrice = parseFloat(btn.getAttribute("data-mc-price")) || 0;
      if (backorderEl) {
        var isBackorder = btn.getAttribute("data-mc-backorder") === "true";
        if (isBackorder) backorderEl.removeAttribute("hidden");
        else backorderEl.setAttribute("hidden", "");
      }
      render();
    });
  });

  purchaseBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      purchaseBtns.forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
      btn.setAttribute("aria-pressed", "true");
      state.subscribe = btn.getAttribute("data-mc-purchase") === "subscribe";
    });
  });

  buyBtns.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (!state.variantId) return;
      var item = { id: parseInt(state.variantId, 10), quantity: 1 };
      if (state.subscribe && data.subscribeSellingPlanId) {
        item.selling_plan = parseInt(data.subscribeSellingPlanId, 10);
      }
      var orig = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      }).then(function () {
        window.location.href = "/cart";
      }).catch(function () {
        btn.disabled = false;
        btn.innerHTML = orig;
        alert("Sorry, couldn't add to cart. Please refresh and try again.");
      });
    });
  });

  if (stickyEl && buyboxEl) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var leftView = e.boundingClientRect.top < 0 && !e.isIntersecting;
        stickyEl.classList.toggle("is-visible", leftView);
      });
    }, { threshold: [0, 1] });
    io.observe(buyboxEl);
    document.body.classList.add("mc-has-sticky");
  }

  if (topBtn) {
    topBtn.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
    var onScroll = function () { topBtn.classList.toggle("is-visible", window.scrollY > 400); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  var rio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("mc-in"); rio.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  root.querySelectorAll("[data-mc-reveal]").forEach(function (el) { rio.observe(el); });

  render();
})();

/* Image gallery */
(function () {
  var root = document.querySelector(".mc-page");
  if (!root) return;
  var gal = root.querySelector("[data-mc-gallery]");
  if (!gal) return;
  var imgs = gal.querySelectorAll(".mc-galimg");
  var dots = gal.querySelectorAll(".mc-galdot");
  if (imgs.length < 2) return;
  var cur = 0;
  function show(idx) {
    idx = ((idx % imgs.length) + imgs.length) % imgs.length;
    imgs[cur].classList.remove("is-active");
    if (dots[cur]) dots[cur].classList.remove("is-active");
    cur = idx;
    imgs[cur].classList.add("is-active");
    if (dots[cur]) dots[cur].classList.add("is-active");
  }
  var prev = gal.querySelector("[data-mc-gal-prev]");
  var next = gal.querySelector("[data-mc-gal-next]");
  if (prev) prev.addEventListener("click", function (e) { e.preventDefault(); show(cur - 1); });
  if (next) next.addEventListener("click", function (e) { e.preventDefault(); show(cur + 1); });
  dots.forEach(function (d) {
    d.addEventListener("click", function (e) {
      e.preventDefault();
      show(parseInt(d.getAttribute("data-mc-gal-idx"), 10));
    });
  });
  /* Swipe support on touch */
  var startX = 0;
  gal.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
  gal.addEventListener("touchend", function (e) {
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
  }, { passive: true });
})();
